export function byKeyComparer<T>(key: keyof T): (a: T, b: T) => number {
  return (a, b) => {
    if (a[key] < b[key]) {
      return -1
    } else if (a[key] > b[key]) {
      return 1
    }
    return 0
  }
}
